/**
 * apps/admin has a separate application identity from apps/web.
 * See AGENTS.md section 4 (Application Boundaries) and
 * docs/project-structure.md section 6 (Admin Application).
 */
export const ADMIN_APP_NAME = "Chaochud Admin";
